module.exports = __webpack_public_path__ + "static/img/zoom_title.8309194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/zoom_title.png
// module id = mxjt
// module chunks = 4